export default __webpack_public_path__ + "static/media/Salame.dc6f69e7.jpg";